import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface ResponsabilidadSvCargoItem {
  id: number;
  id_responsabilidad: number;
  id_cargo: number;
  estado: number;
  ResponsabilidadCargoData?: { id: number; cargos: string; estado: number } | null;
}

export interface ResponsabilidadSvCatalogo {
  id?: number;
  responsabilidad: string;
  descripcion?: string | null;
  estado?: number;
  AsignaResponsabilidadCargoData?: ResponsabilidadSvCargoItem[];
}

export interface ResponsabilidadSvCatalogoPayload {
  responsabilidad: string;
  descripcion?: string | null;
  estado?: number;
}


export interface ResponsabilidadSvCatalogoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ResponsabilidadesSvCatalogoService {
  private readonly apiUrl = `${environment.apiUrl}/api/responsabilidades_sv_catalogo`;

  constructor(private http: HttpClient) {}

  // Listar todas las responsabilidades
  getAll(): Observable<ResponsabilidadSvCatalogo[]> {
    return this.http.get<ResponsabilidadSvCatalogo[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<ResponsabilidadSvCatalogo> {
    return this.http.get<ResponsabilidadSvCatalogo>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nueva responsabilidad
  create(payload: ResponsabilidadSvCatalogoPayload): Observable<ResponsabilidadSvCatalogoResponse> {
    return this.http.post<ResponsabilidadSvCatalogoResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar responsabilidad
  update(id: number, payload: Partial<ResponsabilidadSvCatalogoPayload>): Observable<ResponsabilidadSvCatalogoResponse> {
    return this.http.put<ResponsabilidadSvCatalogoResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar responsabilidad (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar responsabilidad
  inactivar(id: number): Observable<ResponsabilidadSvCatalogoResponse> {
    return this.http.put<ResponsabilidadSvCatalogoResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar responsabilidad
  activar(id: number): Observable<ResponsabilidadSvCatalogoResponse> {
    return this.http.put<ResponsabilidadSvCatalogoResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}